// As abas de Relatórios (REPORTS-03): uma página só, e a aba mora na URL
// (`?tab=`). Cada aba diz o texto, as seções que pede (as rotas de
// `atendimento/*`), se se refaz sozinha ("ao vivo") e a flag sem a qual não
// aparece. Agora é a padrão e não vai na URL.
//
// A flag é `{ account: … }` (um campo da conta, como `cart_links_report_enabled`)
// ou `{ feature: … }` (uma feature flag da conta). Quem chama diz se a conta a
// tem, por `hasFlag(flag)`.
//
// A barra de filtros é uma só, no cabeçalho (fase H), e a aba diz o que muda
// nela: `ownFilters` são as pílulas só dela, e `disabledFilters` as comuns que
// ela não aplica, apagadas com o porquê (`disabledHint`) e mantidas no endereço,
// porque valem nas outras abas.
export const DEFAULT_TAB = 'agora';

export const REPORT_TABS = [
  {
    key: 'agora',
    label: 'ATENDIMENTO_REPORTS.TABS.AGORA',
    sections: ['agora'],
    live: true,
    flag: null,
  },
  // A Números (REPORTS-04 D18), logo depois da Agora: o lugar fácil para ver
  // os totais. Os mapas de calor são rota à parte, porque o agrupamento não os
  // muda. Time e atendente não se aplicam aos disparos, mas valem para o resto
  // da aba: a pílula fica ativa, e a seção diz o que eles não cortam.
  {
    key: 'numeros',
    label: 'ATENDIMENTO_REPORTS.TABS.NUMEROS',
    sections: ['numeros', 'mapa'],
    live: false,
    flag: null,
  },
  // "Fora da conta" mora no Caminho (G11a), e as chamadas de ferramenta dão a
  // tarefa concluída da árvore.
  {
    key: 'caminho',
    label: 'ATENDIMENTO_REPORTS.TABS.CAMINHO',
    sections: ['caminho', 'ferramentas', 'fora'],
    live: false,
    flag: null,
  },
  {
    key: 'ia',
    label: 'ATENDIMENTO_REPORTS.TABS.IA',
    sections: ['ia', 'ferramentas'],
    live: false,
    flag: null,
  },
  // A Equipe lê a Agora uma vez ("Com uma pessoa agora" e os online), sem se
  // refazer sozinha: ao vivo é só a aba Agora (G11b).
  {
    key: 'equipe',
    label: 'ATENDIMENTO_REPORTS.TABS.EQUIPE',
    sections: ['equipe', 'agora'],
    live: false,
    flag: null,
  },
  {
    key: 'canais',
    label: 'ATENDIMENTO_REPORTS.TABS.CANAIS',
    sections: ['comparar'],
    live: false,
    flag: null,
  },
  // Pede as próprias rotas (`campanhas/*`), de dentro da aba e com o filtro
  // dela: a página não pede nada por ela. Só com a flag `outbounds` (G6): a aba
  // só tem dado do Outbound, e sem ela apareceria vazia.
  {
    key: 'campanhas',
    label: 'CAMPANHAS.TAB',
    sections: [],
    live: false,
    flag: { feature: 'outbounds' },
    // O disparo não tem time nem atendente.
    ownFilters: ['campanha', 'template', 'segmento'],
    disabledFilters: ['teamId', 'userId'],
    disabledHint: 'CAMPANHAS.FILTERS.NOT_APPLICABLE',
  },
  // Pede o relatório v2 de links de checkout, e não `atendimento/*`, só pelo
  // período e pelo teste (G10): o backend aceita no máximo um entre caixa, time
  // e atendente (`type/id`), e agente de IA não se aplica.
  {
    key: 'carrinhos',
    label: 'REPORT.CARTS.HEADER',
    sections: ['carrinhos'],
    live: false,
    flag: { account: 'cart_links_report_enabled' },
    disabledFilters: ['agentId', 'inboxId', 'teamId', 'userId'],
    disabledHint: 'REPORT.CARTS.FILTER_NOT_APPLICABLE',
  },
];

export const tabByKey = key => REPORT_TABS.find(tab => tab.key === key);

// As abas que a conta vê, na ordem da faixa.
export const visibleTabs = (hasFlag = () => false) =>
  REPORT_TABS.filter(tab => !tab.flag || hasFlag(tab.flag));

// A aba do endereço. Valor desconhecido, ou aba sem a flag da conta, cai em
// Agora: um link de outra conta não abre uma aba vazia.
export const resolveTab = (value, hasFlag = () => false) =>
  visibleTabs(hasFlag).find(tab => tab.key === value) || tabByKey(DEFAULT_TAB);

// A aba → o valor da URL: a padrão fica fora.
export const tabQuery = key => (key === DEFAULT_TAB ? undefined : key);
